import React from "react";
import "../../OutboundCampaign/OutboundCampaign.css";

/**
 * SMS-only Modal component mirroring the Voice Campaign modal UI/structure,
 * but kept separate to avoid coupling to shared behavior.
 *
 * Props:
 * - show: boolean
 * - title: string
 * - onClose: () => void
 * - body: ReactNode
 * - footer: ReactNode
 * - maxWidth: number|string
 * - loading: boolean
 * - modelindex: string|number (z-index)
 */
export default function ModalSMS({
  show,
  title,
  onClose,
  body,
  footer,
  maxWidth = 600,
  loading = false,
  modelindex,
}) {
  return (
    <div
      className={show ? "modal completedchats fade show" : "modal completedchats fade"}
      data-backdrop="static"
      tabIndex="-1"
      role="dialog"
      data-keyboard="false"
      aria-labelledby="staticBackdrop"
      aria-hidden="true"
      style={{ display: show ? "block" : "none", zIndex: modelindex ?? "999" }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: maxWidth || 600 }}
      >
        {loading && <div className="ui loading form" />}
        <div className="modal-content">
          <button
            type="button"
            className="close linear-gradient"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => onClose && onClose()}
            style={{ zIndex: modelindex ?? "999" }}
          >
            X
          </button>
          <div className={`modal-header ${title ? String(title).replace(/\s/g, "") : ""}`}>
            <h5
              className="modal-title"
              style={{
                fontSize: "1.6rem",
                fontFamily: "Lato,Helvetica Neue,Arial,Helvetica,sans-serif",
              }}
            >
              {title}
            </h5>
          </div>

          <div className="modal-body parsedatap viewemail" style={{ paddingTop: "10px" }}>
            <div style={{ marginLeft: "-5px" }}>{body}</div>
            <div
              className="justify-content-between align-items-center"
              style={{ textAlign: "right" }}
            >
              {footer}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

